<template>
  <component :is="tag" class="toolbar-subtitle">
    <slot />
  </component>
</template>

<script>
export default {
  name: "ToolbarSubtitle",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  }
};
</script>

<style lang="scss">
.toolbar-subtitle {
  font-size: 25px;
  color: colors(text-3);
  font-weight: fw(bold);

  @include breakpoint("xs-only") {
    font-size: 20px;
  }
}
</style>
